module.exports = __webpack_public_path__ + "b8f4e1f5e86ad428c28ac2e03873af9f.svg";